module.exports = __webpack_public_path__ + "static/media/wink.fe67329a.svg";